/* istanbul ignore file */
export { default } from './FormDivider';
